import React, { useState, useEffect } from 'react';
import { Steps, Button, Modal, message } from 'antd';
import BrandTopSubHeaderComponent from '../../components/Brand/Common/BrandTopSubHeaderComponent';
import BrandBaseLayoutComponent from '../../components/Layout/Brand/BrandBaseLayoutComponent';
import './BrandCreateCampaignPage.styles.scss';
import CampStep1Component from '../../components/Brand/Campaign/Create/CampStep1Component';
import CampStep2Component from '../../components/Brand/Campaign/Create/CampStep2Component';
import { dispatch, useGlobalState } from '../../store/state';
import { CampaignLocations } from '../../apis/Brand/Campaigns/CampaignLocations';
import { CampaignInterests } from '../../apis/Brand/Campaigns/CampaignInterests';
import { AiOutlineExclamationCircle } from 'react-icons/ai';
import { useHistory, useParams } from 'react-router-dom';
import { CampaignGetSingle } from '../../apis/Brand/Campaigns/CampaignGetSingle';
import { SyncCampiagnData } from '../../utils/SyncCampiagnData';
import { checkObjectKeyValues } from '../../utils';
import { CampaignSelectLists } from '../../apis/Brand/Campaigns/CampaignSelectLists';
import CampSubmitComponent from '../../components/Brand/Campaign/Create/CampSubmitComponent';
import { GetInfluencerLists } from '../../apis/Brand/InfluencerList/GetInfluencerLists';
const BrandCreateCampaignPage = () => {
  const history = useHistory();
  const params = useParams();
  const { Step } = Steps;
  // const { confirm } = Modal;
  const [user] = useGlobalState('user');
  const [company] = useGlobalState('company');
  const [campDefSet] = useGlobalState('campDefSet');
  const [create_camp_general] = useGlobalState('create_camp_general');
  const [create_camp_draft] = useGlobalState('create_camp_draft');
  // const [current, setCurrent] = useState(0);
  const [paymentstatus, setPaymentstatus] = useState(false);
  const [draftData, setDraftData] = useState(false);

  const { currentPanel } = create_camp_general;
  const steps = [
    {
      title: 'Campaign Settings',
      content: 'First-content',
    },
    {
      title: 'Campaign Breif',
      content: 'Second-content',
    },
    {
      title: 'Status',
      content: 'Last-content',
    },
  ];
  const loadDeafultCreation = () => {
    dispatch({
      type: 'CREATE_CAMP_DATA',
      payload: {
        ...create_camp_draft,
        ...campDefSet,
        brand: '',
        campaignid: '',
      },
    });
    history.push(`/brand/${params.companyId}/campaign/create`);
  };
  useEffect(() =>{
    let unmounted = false; // flag for memory leak prevention
    // note: loading campaign input field structure
    if (!unmounted) {
      // note: getting default select box fields value
      CampaignSelectLists(user.accessToken).then(({ status, response }) =>{
        if (status === 200) {
          const _set1 = response;
          // @note: getting list of available influencerListset
          GetInfluencerLists(user.accessToken, company.selected.id).then(({ status, response })=>{
            console.log('list of infs', response);
            if (status === 200) {
              dispatch({
                type: 'SET_CAMP_GENERAL',
                payload: {
                  ...create_camp_general,
                  defaultSelectBoxData: {
                    ..._set1,
                    influencerListSet: response.list,
                  },
                },
              });
            } else {
              message.error('Failed to get default list');
            }
          });
        }
      });


      if (params.campaignId !== 'create') {
        CampaignGetSingle(user.accessToken, params.campaignId).then((data) =>{
          // console.log("response from view camp==>",data)
          if (data.status === 200) {
            setPaymentstatus(data.response.paymentstatus || false);
            SyncCampiagnData(
              create_camp_draft, // store sync object
              company.selected.id, // active company id
              campDefSet, // default field set for pre filter
              {
                campaignid: data.response.id,
                data: checkObjectKeyValues(data.response),
              }, // updated set of data to process
            );
          } else {
            loadDeafultCreation();
          }
          setDraftData(true);
        });
      } else {
        loadDeafultCreation();
        setDraftData(true);
      }
    } else {
      loadDeafultCreation();
    }
    return () => {
      unmounted = true;
    };
  }, []);
  useEffect(()=>{
    // reset things for return (non-async)
    return () => {
      dispatch({
        type: 'SET_CAMP_GENERAL',
        payload: {
          ...create_camp_general,
          currentPanel: 0,
        },
      });
    };
  }, []);
  // useEffect(() =>{
  //     window.addEventListener("beforeunload", alertUser);
  //     return () => {
  //         window.removeEventListener("beforeunload", alertUser);
  //     };
  // },[])
  // const alertUser = (e) =>{
  //     e.preventDefault();
  //     e.returnValue = "";
  // }
  // const nextStep = () => {
  //     if(currentPanel <= steps.length){
  //         let _gen = create_camp_general
  //         dispatch({
  //             type:'SET_CAMP_GENERAL',
  //             payload:{
  //                 ..._gen,
  //                 currentPanel:  currentPanel + 1
  //             }
  //         })
  //     }
  // };
  const onStepChange = (current) => {
    dispatch({
      type: 'SET_CAMP_GENERAL',
      payload: {
        ...create_camp_general,
        currentPanel: current,
      },
    });
  };
  return (
    <BrandBaseLayoutComponent>
      <BrandTopSubHeaderComponent className="py-3 sticky">
        <div className="px-3">
          <h6 className="common_title m-0"><strong>Create Campaign</strong></h6>
        </div>
      </BrandTopSubHeaderComponent>
      <div className="camp_steps">
        <Steps current={currentPanel}
          onChange={onStepChange}>
          {steps.map((item) => (
            <Step key={item.title}
              title={item.title} />
          ))}
        </Steps>
      </div>
      {/* 1 */}
      {draftData === true ?
        <CampStep1Component
          activePanel={currentPanel}
          className={`step_data ${currentPanel === 0? 'd-block':'d-none'}`}
          paymentstatus={paymentstatus}
        /> :
        null
      }
      {/* 2 */}
      {draftData === true ?
        <CampStep2Component activePanel={currentPanel}
          className={`step_data ${currentPanel === 1? 'd-block':'d-none'}`}/>:
        null
      }
      {/* <div className={`step_data ${current === 1? 'd-block':'d-none'}`}>
                <h3>Step 2</h3>
            </div> */}
      {/* 3 */}
      {draftData === true ?
        <div className={`step_data ${currentPanel === 2? 'd-block':'d-none'}`}>
          <CampSubmitComponent/>
        </div>:
        null
      }

      {/* save continue Button */}
      {/* {
                create_camp_draft.campaignid ?
                <div className="d-flex">
                    <div className="col-md-8 text-right pr-2 pt-3">
                        <Button onClick={nextStep} className="common_button py-3 filled">NEXT STEP</Button>
                    </div>
                </div>
                :null
            } */}
    </BrandBaseLayoutComponent>
  );
};

export default BrandCreateCampaignPage;
